import { Buffer } from "buffer";

const crypto = window.crypto;
const encoder = new TextEncoder();
const decoder = new TextDecoder();
const pbkdfIterationCount = 100000;
const saltBitCount = 16;
const ivBitCount = 12;

export function getKeyMaterial(password) {
  return crypto.subtle.importKey(
    "raw",
    encoder.encode(password),
    "PBKDF2",
    false,
    ["deriveBits", "deriveKey"]
  );
}

async function getKey(keyMaterial, salt) {
  return crypto.subtle.deriveKey(
    {
      name: "PBKDF2",
      salt: salt,
      iterations: pbkdfIterationCount,
      hash: "SHA-256",
    },
    keyMaterial,
    { name: "AES-GCM", length: 256 },
    false,
    ["encrypt", "decrypt"]
  );
}

export async function Encrypt(keyMaterial, dataToEncrypt) {
  const salt = crypto.getRandomValues(new Uint8Array(saltBitCount));
  const iv = crypto.getRandomValues(new Uint8Array(ivBitCount));
  const key = await getKey(keyMaterial, salt);

  const encryptedData = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv: iv },
    key,
    encoder.encode(dataToEncrypt)
  );

  const allEncryptedData = Buffer.from(
    new Uint8Array([...iv, ...salt, ...new Uint8Array(encryptedData)])
  ).toString("base64");

  return allEncryptedData;
}

export async function Decrypt(keyMaterial, dataToDecrypt) {
  const salt = Uint8Array.fromBase64(dataToDecrypt).slice(
    ivBitCount,
    ivBitCount + saltBitCount
  );
  const key = await getKey(keyMaterial, salt);

  return decoder.decode(
    await crypto.subtle.decrypt(
      {
        name: "AES-GCM",
        iv: Uint8Array.fromBase64(dataToDecrypt).slice(0, ivBitCount),
      },
      key,
      Uint8Array.fromBase64(dataToDecrypt).slice(ivBitCount + saltBitCount)
    )
  );
}
